import { GetFlatPublicAWS } from "./utils"
import CloudHandler, { ping } from "./cloud-zones"
import { cloudZones } from "./__mocks__/cloud-zones.mock"

const staticZones = cloudZones

export { GetFlatPublicAWS, ping, staticZones }

export default CloudHandler
